import { render, staticRenderFns } from "./InstructionStepCardV2.vue?vue&type=template&id=7b823a08&scoped=true"
import script from "./InstructionStepCardV2.vue?vue&type=script&setup=true&lang=js"
export * from "./InstructionStepCardV2.vue?vue&type=script&setup=true&lang=js"
import style0 from "./InstructionStepCardV2.vue?vue&type=style&index=0&id=7b823a08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b823a08",
  null
  
)

export default component.exports